<!--
 by:wangyingyu
 2019.9.17
 -->
<template>
    <div class="header">
        <!-- logo -->
        <div class="logo fl">
            <img v-if="navbardata.domainConfig" :src="navbardata.domainConfig.navLogoUrl" alt="" width="180" height="50px">
        </div>
        <ul class="fl">

            <!-- 普通样式 -->
            <li v-for="(item,index) in navbardata.authPrivileges" :key='index' @contextmenu="opennew(item.pc)" @click="changeBar(item.pc)" v-if="item.bt!='UCT'&&item.pc!='msg_center'&&item.pc!='customer_o_input'&&item.pc!='dev_doc' && item.sp !=3 && item.au"
                :class="{active:indexActive ==item.pc}">
                <a :href="item.bt|realurl(navbardata.domainConfig,item.au)" target="_self" v-if="item.pc!='wx_im'">{{item.nm}}</a>
                <router-link to="/router=im/chat_page" v-else>{{item.nm}}</router-link>
            </li>

            <!-- 机会录入CRM -->
           <li class="chanceInput" v-for="(item,index) in navbardata.authPrivileges" :key='index'  v-if="item.pc=='customer_o_input'">
               <a id="customer_o_input" href="JavaScript:;" @click="showopportunity" class="iconfont">&#xe6ef;</a>
           </li>
			<li v-for="(item,index) in navbardata.authPrivileges" :key='index'  v-if="item.pc=='globlal_search'" >
				<globalSearch v-show="globalSearchShow" :uniqueFiled="uniqueFiled"></globalSearch>
			</li>

            <!-- 外接电话 -->
            <!-- <li class="phoneLists">
               <call></call>
            </li> -->


        </ul>

        <div class="headRight">
            <!-- 消息 -->
            <!-- <message class="fl"></message> -->
            <!-- 个人中心 -->

            <div class="peopleCenter fl" v-if="navbardata" @mouseenter="peopleCenterShow =true" @mouseleave="peopleCenterShow =false">
                <a href="JavaScript:;">{{navbardata.user.realName}}</a>
                <i class="iconfont">&#xe600;</i>
                <!-- <transition name="fade"> -->
                    <div class="peopleCenterLists" v-show="peopleCenterShow" >
                        <ul class="clearfix">
                            <!-- 系统设置 -->
                            <li v-for="(item,index) in navbardata.authPrivileges" :key='index' v-if="item.pc=='sys_setting'|item.pc=='user_setting'|item.pc=='msg_center'|item.pc=='dev_doc'" :class="{active:indexActive ==index}">
                                <a :href="item.bt|realurl(navbardata.domainConfig,item.au)" target="_self">
                                    <i class="iconfont" v-html="item.si"></i>{{item.nm}}</a>
                            </li>
							<li @click="watchQrcode" v-if="qrcodeShow">
								<a href="javascript:;">
									<i class="iconfont">&#xe63e;</i>
									下载固码
								</a>

							</li>
                            <li>
                                <a :href="loginouturl+'/sso/logout'">
                                    <i class="iconfont">&#xe7de;</i>
                                    退出登录
                                </a>
                            </li>
                        </ul>
                    </div>
                <!-- </transition> -->
            </div>

        </div>

        <el-drawer
          :with-header="false"
          :visible.sync="drawer"
          direction="rtl"
          class="eldrawer">
          <opportunity v-if="drawer" :crmurl="crmurl" ></opportunity>
        </el-drawer>
		<el-dialog
			width="347px"
			title="扫码支付"
			v-show="qrcodeDialogVisible"
			:visible.sync="qrcodeDialogVisible"
			:before-close="handleQrcodeClose">
			<div class="select-box">
				<el-select v-model="payCode" placeholder="请选择" size="mini" class="select" @change="getPayCodeInfoInit">
					<el-option
						v-for="item in payCodeList"
						:key="item.id"
						:label="item.channelName"
                        v-show="item.thirdPartyType !== 'XTB'"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="background-img-style" ref="capImg">
				<img :src="payCodeInfo.payImgUrl" alt="" >
				<div id="qrcode" ref="qrcode"  class="background-img-qrcode"></div>
			</div>
			<el-button type="primary" class="qrcode-btn" @click.stop="downloadQrcode">下载支付二维码</el-button>

		</el-dialog>
    </div>
</template>

<script>
	import html2canvas from 'html2canvas';
	import GlobalSearch from '../../../components/GlobalSearch'
	import QRCode from 'qrcodejs2'
	import { mapGetters } from 'vuex'
	import axios from 'axios'
    import Message from "../../../components/message";
    import Call from "../../../components/call";
    import { opportunity } from "../../customerservice/components"
    export default {
        name: "Navbar",
        components: {Message,Call,opportunity, GlobalSearch },
        data() {
            return {
                indexActive: '',
                messageShow: false,
                peopleCenterShow: false,
                loginouturl:'/',
			    qrcodeDialogVisible:false,
              	payCodeInfo:{},
              	qrcodeShow:false,
                qrcodeSwitch:false,
			    show:true,
                crmurl:'',
                drawer: false,
              List:[],
              payCode:'',
              payCodeList:[],
              globalSearchShow:false, //是否显示全局搜素
              uniqueFiled:[], // 全局搜素用的
              inputSuffix:''
            }
        },
        watch:{
            $route(to) {
                console.log(to.name,'to.nameto.nameto.nameto.name')
                if(to.name == 'chat'|| to.name == 'friendslist'){
                    this.indexActive ='wx_im'
                }
            },
        },
        computed:{
            ...mapGetters('im',{
                navbardata:'currentUser'
            })
        },
        mounted() {
            let domainConfig = localStorage.getItem('userInfo')
            this.crmurl = JSON.parse(domainConfig).domainConfig.crmDomain
            this.loginouturl = JSON.parse(domainConfig).domainConfig.ssoDomain
            this.IFRAME_LOAD = window.sessionStorage.getItem("IFRAME_LOAD");
            let router_path = this.$route.path
            if(router_path.indexOf('/router=im/') != -1){
                this.indexActive ='wx_im'
            }
            this.getOpenPayStatus()
		    this.findUniqueFiled()
            const _this = this
            window.addEventListener('message', function(event) {
                let data = event.data
                if (data == 3 || data == 'msg') {
                    _this.drawer = false
                }
            }, false);
        },
        created(){
            if (localStorage.getItem("nstore") && !this.navbardata.user) {
                let oldstore = JSON.parse(localStorage.getItem("nstore"));
                oldstore.im.selectfriend = {
                    wechatContactinfo: {
                        friendid: '',
                        wechatid: ''
                    }, //当前聊天好友信息
                    wechatMessage: {
                    lastmsgid: 0,
                    data: []
                    } //当前好友聊天记录信息
                };
                oldstore.im.chatdata = {
                    records: [],
                    total: 0
                };
                this.oldid = oldstore.im.userMsg.user ? oldstore.im.userMsg.user.id : "";
                this.$store.replaceState(Object.assign({}, this.$store.state, oldstore));
                localStorage.removeItem("nstore")
            }
        },
      methods: {
          opennew(pc){
              if(pc == "wx_im"){
                localStorage.setItem("nstore", JSON.stringify(this.$store.state));
              }
          },
          getOpenPayStatus(){
            const companyId = this.navbardata.user.companyId
            if(this.navbardata.domainConfig.hasOwnProperty('crmApiDomain')){
              axios({
                url:`/apiPayOrder/openPayStatus?companyId=${companyId}`,
                baseURL: this.navbardata.domainConfig.crmApiDomain,
				data:{},
                method:'post',
				isReplaceHeaders:true,
                headers: {
                  "crmApiToken": window.localStorage.getItem("initToken")
				}
              }).then(res=>{
                if (res.data.code === 200){
                 const isOpenNSPOS =  res.data.data.isOpenNSPOS
				  if(isOpenNSPOS === 1){
                    axios({
                      url: '/apiPayOrder/getChannelName ',
                      baseURL: this.navbardata.domainConfig.crmApiDomain,
                      data:{},
                      method:'post',
                      isReplaceHeaders:true,
                      headers: {
                        "crmApiToken": window.localStorage.getItem("initToken")
                      }
                    }).then(r=>{
                      if (r.data.code === 200){
                          let PayCode = []
                          if(r.data.data['1']) {
                              PayCode = [...r.data.data['1']]
                          }
                          if(r.data.data['2']) {
                              PayCode = PayCode.concat(r.data.data['2'])
                          }
						this.payCodeList = PayCode.filter(v => { return v.thirdPartyType !== 'XTB' })
						this.payCode = this.payCodeList[0].id
                        this.qrcodeShow = true
                        this.getPayCodeInfo(this.payCodeList[0].id)
                      }else{
                        this.$toast(r.data.msg)
                      }
                    })
				  }

				}else{
					this.$toast(res.data.msg)
				}
              })
			}
          },
		  getPayCodeInfoInit(data){
			  this.getPayCodeInfo(data)
		  },
          getPayCodeInfo(companyPayConfigId){
            const companyId = this.navbardata.user.companyId
            axios({
              url:`/apiPayOrder/payCodeInfo?companyPayConfigId=${companyPayConfigId}`,
              baseURL: this.navbardata.domainConfig.crmApiDomain,
              data:{},
              method:'POST',
              isReplaceHeaders:true,
              headers: {
                "crmApiToken": window.localStorage.getItem("initToken")
              }
            }).then(res=>{
              if (res.data.code === 200){
                console.log(res.data.data,'这回是二维码')
                this.payCodeInfo = res.data.data
                this.$nextTick(() => {
                  if(document.getElementById('qrcode')){
                    document.getElementById('qrcode').innerHTML = ''
                    this.creatQrcode();
				  }
                })
              }else{
                this.$toast(res.data.msg)
              }
			})
		  },
          handleQrcodeClose(){
            this.qrcodeDialogVisible = false;
		  },
          watchQrcode(){
            this.qrcodeDialogVisible = true;
              this.$nextTick(() => {
                if(document.getElementById('qrcode')){
                  document.getElementById('qrcode').innerHTML = ''
                }
                this.creatQrcode();
              })

		  },
       	  creatQrcode () {
            this.qrcodeSwitch = true
		    let qrcode = new QRCode('qrcode', {
				width: 156, // 设置宽度，单位像素
				height: 156, // 设置高度，单位像素
				text: this.payCodeInfo.payUrl   // 设置二维码内容或跳转地址
			  })

          },
		  downloadQrcode(){
           html2canvas(this.$refs.capImg,{
             useCORS: true,
             backgroundColor:null,
           }).then(canvas => {
             // this.$refs.addImage.append(canvas);//在下面添加canvas节点
             let link = document.createElement("a");
             link.href = canvas.toDataURL();//下载链接
             link.setAttribute("download","支付码.png");
             link.style.display = "none";//a标签隐藏
             link.click();
           });
		 },
		  changeBar(n) {
                this.indexActive = n
            },
		  showopportunity(){
                this.drawer =true
            },
		  findUniqueFiled() {
			  axios({
				url: '/apiRuleConfig/findUniqueFiled',
				baseURL: this.navbardata.domainConfig.crmApiDomain,
				data: {},
				method: 'post',
				isReplaceHeaders: true,
				headers: {
				  "crmApiToken": window.localStorage.getItem("initToken")
				}
			    }).then(res => {
			      if (res.data.code === 200){
                    this.uniqueFiled = res.data.data;
                    console.log(this.uniqueFiled)
                    this.globalSearchShow = true
				  }else{
			        this.$toast(data.msg)
				  }
			  })
			}
        }
    }
</script>

<style scoped lang="less">
	*{
		box-sizing: content-box !important;
	}
    /* head */
    .header {
        width: 100%;
        height: 50px;
        line-height: 50px;
        background: #1D232A;
        font-size: 14px;
        min-width: 1500px;


        .logo {
            width: 190px;
            height: 50px;
            text-align: center;
        }

        ul li {
            float: left;
            height: 50px;
            padding: 0 10px;

            &.active {
                a {
                    color: #0099FF;
                }
            }
            .router-link-active{
                color: #0099FF;
            }

            a {
                color: #fff;
            }

            &.chanceInput{
                a{
                    font-size: 22px;
                    color: #0099FF;
                }
            }
        }

        /* 机会录入 */
        .headSelect {
            &>a {
                border: 1px solid white;
                padding: 5px 10px;
                height: 20px;
                line-height: 20px;
                border-radius: 6px;
                text-align: center;
                display: inline-block;

            }

            ul {
                background: #24252a;
                position: absolute;
                top: 50px;
                display: none;
                z-index: 999;

                li {
                    width: 78px;
                    height: 30px;
                    padding: 0px;
                    background: #1b1b1b;
                    line-height: 30px;
                    text-align: center;
                    color: white;
                    clear: left;

                    a {
                        display: inline-block;
                        width: 100%;
                        line-height: 30px;
                        color: #fff;
                    }

                    &:hover a{
                        color: #0099ff;
                    }
                }
            }

            &:hover ul {
                display: block;
            }
        }

        /* 外接电话*/
        .phoneLists{
            &>a {
                width:175px;
                height:30px;
                background:rgba(235,237,242,0.1);
                border-radius:3px;
                padding: 0 10px;
                line-height: 30px;
                text-align: center;
                display: inline-block;
                margin-top: 15px;

                i:first-child{
                    background: #fff;
                    color: #009933;
                    float: left;
                    height: 16px;
                    width: 16px;
                    border-radius: 50%;
                    line-height: 16px;
                    text-align: center;
                    margin-top: 7px;
                    font-size: 18px;
                }
                i:last-child{
                    float: right;
                    height: 16px;
                    font-size: 12px;
                }
            }
        }

        /* 我的状态 */
        .myState {

            &>a {
                border: none;
                margin-left: 6px;
            }

            span {
                width: 12px;
                height: 12px;
                display: inline-block;
                border-radius: 50%;
                vertical-align: middle;
                margin-right: 8px;
            }

            .myState_on {
                background-color: #009933;
            }

            .myState_off {
                background-color: #fc0304;
            }
        }

        /* 右侧盒子 */
        .headRight {
            position: absolute;
            top: 0;
            right: 0;

            a {
                color: #fff;
                position: relative;

                .myMessagenum{
                    position: absolute;
                    top: 3px;
                    left: 14px;
                    padding: 2px 6px;
                    height: 14px;
                    line-height: 14px;
                    font-size: 12px;
                    border-radius: 16px;
                    background: red;
                    color: #fff;
                }
            }

            /* 消息 */
            .myMessage {

                .messageBox {
                    width: 280px;
                    background: #fff;
                    background-clip: padding-box;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
                    position: absolute;
                    top: 58px;
                    left: -220px;
                    z-index: 9999;

                    li {
                        float: initial;
                        border-bottom: 1px solid #eee;
                        height: 56px;
                    }

                    a {
                        color: #000000;
                        display: block;
                        padding-left: 20px;

                        &>.fl {
                            height: 56px;
                            width: 40px;

                            i{
                                border-radius: 20px;
                                padding: 5px 6px;
                                background: #0099ff;
                                color: #fff;
                                font-size: 26px;
                            }
                        }

                        .messageinfo {
                            width: 190px;
                            height: 56px;
                            float: left;
                            font-size: 12px;

                            h6{
                                font-weight: 500;
                                height: 20px;
                                line-height: 20px;
                                margin-top: 7px;
                            }

                            .messagebot{
                                height: 20px;
                                line-height: 20px;
                                color: #777;
                            }
                        }
                    }

                    &>a{
                        height: 30px;
                        line-height: 30px;
                        text-align: center;

                        &:hover{
                            color: #0099ff;
                        }
                    }

                }

                .title {
                    background: #24252a;
                    color: #fff;
                    height: 40px;
                    line-height: 40px;
                    padding: 0 10px;
                    text-align: left;
                }
            }

            /* 个人中心 */
            .peopleCenter {
                margin-right: 20px;
                width: 132px;
                position: relative;

                a {
                    display: block;
                    width: 92px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    line-height: 50px;
                    text-align: center;
                    position: relative;
                }

                i {
                    margin-right: 8px;
                    font-size: 14px;
                }

                &>i{
                    position: absolute;
                    right: 0;
                    top: 0;
                    color: #fff;
                }

                .peopleCenterLists {
                    position: absolute;
                    top: 50px;
                    left: 0;
                    width: 132px;
                    background: #24252a;
                    text-align: center;
                    border-radius: 0 0 5px 5px;
                    z-index: 9999;

                    li {
                        float: initial;
                        height: 40px;
                        line-height: 40px;

                        a {
                            line-height: 40px;
                        }

                        &:hover a{
                            color: #0099ff;
                        }
                    }
                }
            }

        }
    }


    .fade-enter,
    .fade-leave-active {
        transform: translateY(-10px);
        opacity: 0;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all ease .5s;
    }

    .iconfont{
        font-size: 25px;
    }
    .eldrawer{
        margin-top: 60px;
    }
	/*二维码*/
	.background-img-style{
		position: relative;
		width: 278px;
		text-align: center;
		margin: 0 auto;
		img{
			width: 278px;
			height: 378px;
			border-radius:10px;
		}
		.background-img-qrcode{
			position: absolute;
			z-index: 20;
			top: 75px;
			left: 48px;
			padding: 13px;
			background: #fff;
			width: 156px;
			height: 156px;
		}
	}
	.qrcode-btn{
		margin-left: 14px;
        width: 238px;
        vertical-align: top;
	}
	.select-box{
		width: 100%;
		height: 50px;
		overflow: hidden;
		text-align: center;
		.select{
			margin: 0 auto;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue